import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { TaskSquare } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const TaskListButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isTaskList: ctx.editor.isActive('taskList') ?? false
      }
    }
  })

  const onToggleTaskList = () => {
    editor.chain().focus().toggleTaskList().run()
  }

  return (
    <Tooltip title={t('editor.task_list')}>
      <Button
        icon={<TaskSquare size={14} />}
        onClick={onToggleTaskList}
        type={editorState.isTaskList ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
